import Breadcrumbs from "@atlaskit/breadcrumbs";

export default Breadcrumbs;
